import React from 'react';
import SportImage from '../custom-widgets/SportImage';

const OptimizedImage = (props) => {
    const { fetchPriority, fetchpriority, src, fallbackSrc, ...rest } = props;
    return <SportImage src={src} fallbackSrc={fallbackSrc} {...rest} />;
};

export default OptimizedImage;
